var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({attrs:{"color":_vm.chipColor},on:{"click":_vm.onClick}},'v-chip',_vm.$attrs,false),[_c('v-icon',{attrs:{"color":_vm.checkBoxColor,"left":""}},[_vm._v(" "+_vm._s(_vm.checkBoxIcon)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }